<template>
  <div v-if="questions" id="exercisePrint">
    <button class="print-report-btn" @click.prevent="print">הדפסה</button>
    <div v-if="isMultipleQuestions" class="exercise-title">
      <div style="font-size: 2em">שאלות בתרגול</div>
    </div>
    <div v-else class="exercise-title">
      <div style="font-size: 2em">תרגול: <span style="font-weight: bold;">{{ exerciseName }}</span></div>
      <div style="font-size: 2em">מתוך: {{ categoryName || '' }}</div>
    </div>
    <div class="question" :class="{ 'with-detailed-answer': question.detailedAnswer }" v-if="questions" v-for="(question, index) in questions" :key="question.id">
        <div class="question-header">
          <b>{{ index + 1 }}.</b>
          <span class="question-text" v-html="question.question"></span>
        </div>
        <div v-for="answer in question.answers" class="answer">
          <span class="dot"><b>{{ answer.sortOrder | letterize }}</b></span>
          <span v-html="answer.answer"></span>
          <b-icon v-if="answer.isCorrect" style="color: green" icon="check"> </b-icon>
        </div>
        <div v-if="question.detailedAnswer" class="questionText">
          <div>תשובה מפורטת</div>
          <span v-html="question.detailedAnswer"></span>
        </div>
    </div>
    <div class="signature">הודפס ממערכת הסימולטור - המתמחה מבית נבו</div>
  </div>
</template>
<script>
import LessonService from '../services/LessonService';


export default {
  name: "ExercisePrint",
  filters: {
    letterize: function (value) {
      switch (value) {
        case 1: return 'א.'; break;
        case 2: return 'ב.'; break;
        case 3: return 'ג.'; break;
        case 4: return 'ד.'; break;
        default: return;
      }
    }
  },
  data() {
    return {
      isLoading: false,
      exerciseName: null,
      categoryName: null,
      questions: null,
      isMultipleQuestions: false
    };
  },
  components: {

  },
  computed: {
    courseId() {
      return this.$store.state.auth.course.id;
    },
  },
  created() {
    const showAnswers = this.$route.query.showAnswers;
    if (this.$route.query.qIds) {
      this.isMultipleQuestions = true;
      const qIds = this.$route.query.qIds.split(',');
      LessonService.printQuestions(showAnswers, qIds)
        .then((r) => {
          this.questions = r.data;
          console.log(this.questions);
        })
    } else {
      LessonService.printExercise(this.$route.params.exerciseId, showAnswers)
        .then((r) => {
          this.exerciseName = r.data.exerciseName;
          this.categoryName = r.data.categoryName;
          this.questions = r.data.questions;
        });
    }
  },
  methods: {
    print: function (solution) {
      var printed = document.execCommand('print', false, null);
      if (!printed) {
        window.print();
      }
    },
  },
  watch: {
  },
};
</script>
<style scoped lang="scss">
.exercise-title {
  padding: 15px;
}

#exercisePrint {
  width: 100%;
  position: relative;
  font-size: 16px;
  background: #FFF;
}

#exercisePrint h1 {
  margin: 0;
}

#exercisePrint button {
  position: absolute;
  top: 4px;
  left: 20px;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  color: #333;
  border: 1px solid #ccc;
}

#exercisePrint button:hover {
  background: #DDD;
}

#exercisePrint .signature {
  font-size: 12px;
}

.question {
  text-align: justify;
  padding: 30px;
  line-height: 1.5;
  border-bottom: 1px solid #ccc;
  width: 100%;
}

.question:first-of-type {
  border-top: 1px solid #ddd;
}

.question .answer {
  display: flex;
  gap: 10px;
  align-items: baseline;
  padding: 10px;
}

.question .answer .dot {
  height: 7px;
  width: 7px;
  display: inline-block;
  border-radius: 50%;
  background-color: white;
  border-color: gray;
  border: 1px solid gray;
}

.questionText {
  padding: 10px;
  box-shadow: 0px 0px 15px 2px rgba(177, 177, 179, 1);
  margin: 25px 0;
}

.questionText>div {
  font-weight: bold;
  padding: 10px;
}

@media print {
  * {
    font-size: 16px !important;
  }

  body,
  html,
  #page-container,
  .scrollable-page,
  .ps,
  .panel {
    height: 100% !important;
    width: 100% !important;
    display: inline-block;
  }

  .questionText {
    box-shadow: none;
  }

  /* Questions with detailed answers get their own page */
  .question.with-detailed-answer {
    page-break-after: always !important;
  }

  /* Avoid page break after the last question */
  .question.with-detailed-answer:last-of-type {
    page-break-after: avoid;
  }

  /* For questions without detailed answers, keep the original 2-per-page behavior */
  .question:not(.with-detailed-answer):nth-child(2n) {
    page-break-after: always !important;
  }

  .question:not(.with-detailed-answer):nth-child(2n):last-child {
    page-break-after: avoid;
  }

  .print-report-btn {
    display: none !important;
  }

}
::v-deep .indent-1 {
    margin-right: 20px !important;
}

::v-deep .indent-2 {
    margin-right: 40px !important;
}

::v-deep .indent-3 {
    margin-right: 60px !important;
}

::v-deep .indent-4 {
    margin-right: 80px !important;
}

::v-deep .indent-5 {
    margin-right: 100px !important;
}

::v-deep .indent-6 {
    margin-right: 120px !important;
}

::v-deep .indent-7 {
    margin-right: 140px !important;
}

::v-deep .indent-8 {
    margin-right: 160px !important;
}

::v-deep .indent-9 {
    margin-right: 180px !important;
}

::v-deep .indent-10 {
    margin-right: 200px !important;
}

.question-header {
    display: flex;
}

.question-header > b {
  margin-left: 5px;
}

</style>
<!-- 
<style lang="scss">
.LayoutInApp__Component {
  height: 100% !important;
}
</style> -->
